import { render, staticRenderFns } from "./VerifyForm.vue?vue&type=template&id=635ed1aa&scoped=true"
import script from "./VerifyForm.vue?vue&type=script&lang=js"
export * from "./VerifyForm.vue?vue&type=script&lang=js"
import style0 from "./VerifyForm.vue?vue&type=style&index=0&id=635ed1aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635ed1aa",
  null
  
)

export default component.exports